import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { Button as AntButton } from 'antd';

const Button = forwardRef(({ to, type, style, children, ...props }, ref) => {
  const button = (
    <AntButton
      ref={ref}
      {...props}
      type={type}
      style={type === 'link' ? { height: 'fit-content', padding: 0, ...style } : style}
    >
      {children}
    </AntButton>
  );

  return to ? (
    <Link to={to} style={{ display: 'flex' }}>
      {button}
    </Link>
  ) : (
    button
  );
});

export default Button;
